import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
// slices
import mailReducer from './slices/mail';
import usersReducer from './slices/users';
import profileReducer from './slices/profile';
import rolesReducer from './slices/roles';
import chatReducer from './slices/chat';
import productReducer from './slices/product';
import calendarReducer from './slices/calendar';
import kanbanReducer from './slices/kanban';
import collectionReducer from './slices/collection';
import analyticsReducer from './slices/analytics';
import projectReducer from './slices/projects';
import organizationReducer from './slices/organization';

// ----------------------------------------------------------------------

const rootPersistConfig = {
  key: 'root',
  storage,
  keyPrefix: 'redux-',
  whitelist: [],
};

const projectPersistConfig = {
  key: 'project',
  storage,
  keyPrefix: 'redux-',
  // whitelist: ['sortBy', 'checkout'],
};

const organizationPersistConfig = {
  key: 'organization',
  storage,
  keyPrefix: 'redux-',
};

const productPersistConfig = {
  key: 'product',
  storage,
  keyPrefix: 'redux-',
  whitelist: ['sortBy', 'checkout'],
};

const rootReducer = combineReducers({
  projects: persistReducer(projectPersistConfig, projectReducer),
  organization: persistReducer(organizationPersistConfig, organizationReducer),
  mail: mailReducer,
  chat: chatReducer,
  calendar: calendarReducer,
  kanban: kanbanReducer,
  users: usersReducer,
  profile: profileReducer,
  roles: rolesReducer,
  collections: collectionReducer,
  analytics: analyticsReducer,
  product: persistReducer(productPersistConfig, productReducer),
});

export { rootPersistConfig, rootReducer };
